import { FC, useMemo } from 'react';
import { CheckboxList, GenericItem } from '../CheckboxList';
import { useFormContext } from 'react-hook-form';

type LabelCheckboxListProps = {
  actionIndex: number;
  argumentIndex: number;
  items?: Record<string, GenericItem[]>;
};

export const LabelCheckboxActionList: FC<LabelCheckboxListProps> = ({
  actionIndex,
  argumentIndex,
  items,
}) => {
  const { watch, setValue } = useFormContext();

  const { actions } = watch('actions');

  const currentArgument = actions[actionIndex].arguments[argumentIndex];

  const selectedItems = useMemo(() => {
    return Array.isArray(currentArgument?.collectionElementType?.ids)
      ? (currentArgument?.collectionElementType?.ids as string[])
      : [];
  }, [currentArgument, items]);

  const toggleInArray = (item: GenericItem, elements: string[]) => {
    return elements.includes(item.id as string)
      ? elements.filter(elId => elId !== item.id)
      : [...elements, item.id];
  };

  const clickHandler = (item: GenericItem) => {
    const updatedExpected = toggleInArray(
      item,
      currentArgument?.collectionElementType?.ids || []
    );

    const newArgument = {
      ...currentArgument,
      collectionElementType: {
        type: currentArgument.collectionElementType.type,
        ids: updatedExpected,
      },
    };
    setValue(
      `actions.actions[${actionIndex}].arguments[${argumentIndex}]`,
      newArgument
    );
  };

  return (
    <CheckboxList
      items={items}
      onItemToggle={clickHandler}
      selectedItems={selectedItems}
    />
  );
};
